import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    TableHead,
    TableCell,
    TableRow,
    Table,
    TableBody,
    Button
} from '@material-ui/core';
import ThemedTableRow from '../../components/shared/ThemedTableRow';
import { Tooltip } from 'react-tippy';

const styles = theme => ({
    root: {
        margin: '1rem'
    },        
    registerUserContainer: {
        marginTop:'30px'
    },    
    header : {
        marginLeft: '20px',
        fontSize: '18px',
        paddingTop : '10px',
        paddingBottom: "10px"
    },
    appLinkCell: {
        whiteSpace: 'nowrap'
    },
    appLinkButton: {
        marginRight: theme.spacing.unit / 2,
        minWidth: 'auto',
        paddingLeft: theme.spacing.unit,
        paddingRight: theme.spacing.unit
    }
});

class UsersTable extends Component {        

    genTableHeader() {    
        return (
          <TableHead>
            <TableRow>
              <TableCell>Email</TableCell>
              <TableCell>First Name</TableCell>
              <TableCell>Petroff Access</TableCell>
              <TableCell>Skyline Access</TableCell>
              <TableCell>Mobile Only</TableCell>
              <TableCell>App install email</TableCell>
            </TableRow>
          </TableHead>
        )
    }   

    genTableRows() {
        const { users, rowClicked, onRequestAppDownloadEmail, classes } = this.props;
        return users.map((user, index) => {
            const petroffAccessLabel = user.petroffAccess ? "Yes" : "No";
            const skylineAccessLabel = user.skylineAccess ? "Yes" : "No";
            const mobileOnlyLabel = user.mobileOnly ? "Yes" : "No";
            return (
                <ThemedTableRow
                    id='user-row'
                    key={`user-row-${index}`}
                    onClick={e => rowClicked(user)}>
                    <TableCell id='email-cell'>
                        <Tooltip trigger="mouseenter"
                            theme='light'
                            size='small'
                            useContext html={(<p>{user.email}</p>)}>{user.email}
                        </Tooltip>
                    </TableCell>
                    <TableCell>
                        <Tooltip trigger="mouseenter"
                            theme='light'
                            size='small'
                            useContext html={(<p>{user.firstName}</p>)}>{user.firstName}
                        </Tooltip>
                    </TableCell>
                    <TableCell id='petroff-access'>
                        <Tooltip trigger="mouseenter"
                            theme='light'
                            size='small'
                            useContext html={(<p>{petroffAccessLabel}</p>)}>{petroffAccessLabel}
                        </Tooltip>
                    </TableCell>
                    <TableCell id="skyline-access">
                        <Tooltip trigger="mouseenter"
                            theme='light'
                            size='small'
                            useContext html={(<p>{skylineAccessLabel}</p>)}>{skylineAccessLabel}
                        </Tooltip>
                    </TableCell>
                    <TableCell id="mobile-only">
                        <Tooltip trigger="mouseenter"
                            theme='light'
                            size='small'
                            useContext html={(<p>{mobileOnlyLabel}</p>)}>{mobileOnlyLabel}
                        </Tooltip>
                    </TableCell>
                    <TableCell
                        className={classes.appLinkCell}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {user.petroffAccess ? (
                            <Button
                                size="small"
                                color="primary"
                                variant="outlined"
                                className={classes.appLinkButton}
                                onClick={() =>
                                    onRequestAppDownloadEmail &&
                                    onRequestAppDownloadEmail(user.email, 'petroff')
                                }
                            >
                                Petroff
                            </Button>
                        ) : null}
                        {user.skylineAccess ? (
                            <Button
                                size="small"
                                color="primary"
                                variant="outlined"
                                className={classes.appLinkButton}
                                onClick={() =>
                                    onRequestAppDownloadEmail &&
                                    onRequestAppDownloadEmail(user.email, 'skyline')
                                }
                            >
                                Skyline
                            </Button>
                        ) : null}
                        {!user.petroffAccess && !user.skylineAccess ? '—' : null}
                    </TableCell>
                </ThemedTableRow>
            )
        });
    }

    render() {        
        const { classes } = this.props;
        return(
            <div>
                <div className={classes.header}>Users</div>

                <Table>
                {this.genTableHeader()}
                <TableBody>
                    {this.genTableRows()}
                </TableBody>
                </Table>                
            </div>
        )
    }
}

export default withStyles(styles)(UsersTable);